import palette from "../../palette";

export default {
  root: {
    backgroundColor: palette.white
  },
  indicator: {
    backgroundColor: palette.blueMain
  }
};
